export default "__VITE_ASSET__qM4$lvSt__"